import React from "react"
import SiteFooter from "@src/components/site-footer"
import { SOCIAL_MEDIA as socialMediaLinks } from "@src/utils/constants/social-media"
import { footerItems } from "@src/utils/constants/nav-links/bottom-nav-links"
import { legalLinks } from "@src/utils/constants/nav-links/bottom-legal-links"

const Footer = () => {
  return (
    <SiteFooter
      legalLinks={legalLinks}
      footerLinks={footerItems}
      socialMediaLinks={socialMediaLinks}
    />
  )
}
export default Footer
